import React from 'react';
import './aboutpresentation.css';
import aboutContent from '../../../content/pages/about.json';

const AboutPresentation = () => {
    const { heading, paragraphs } = aboutContent.presentation;

    return (
        <section className='about-presentation'>
            <h1>{heading}</h1>
            {paragraphs.map((text, index) => (
                <p key={index}>{text}</p>
            ))}
            <img src="/images/logotyper/bramidan_presto.svg" alt="Bramidan Presto logo" className="bramidan-presto-logo" />
        </section>
    );
};

export default AboutPresentation;
